import { render, staticRenderFns } from "./UITimePicker.vue?vue&type=template&id=126cb124&scoped=true"
import script from "./UITimePicker.vue?vue&type=script&lang=js"
export * from "./UITimePicker.vue?vue&type=script&lang=js"
import style0 from "./UITimePicker.vue?vue&type=style&index=0&id=126cb124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126cb124",
  null
  
)

export default component.exports